import { Stack, Typography } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import * as React from "react";
import { useFormatAmount } from "../../../shared";

export const StatsCards = (props) => {
  const { data } = props;
  const formatAmount = useFormatAmount();
  // const colors = [
  //   "#A04D3D",
  //   "#5E7360",
  //   "#564845",
  //   "#9A8260",
  //   "#A04D3D",
  //   "#5E7360",
  //   "#564845",
  //   "#9A8260",
  // ];

  const formatValue = (value) => {
    if (value.type === "currency") {
      return formatAmount(value.current);
    }
    const numeric = Number(value.current);
    return Number.isFinite(numeric) ? numeric.toLocaleString() : value.current;
  };

  return (
    <Stack
      sx={{
        flexDirection: "row",
        rowGap: "24px",
        columnGap: "38px",
        flexWrap: "wrap",
        mb: "24px",
      }}
    >
      {data?.map((value, i) => {
        const progress = Number(value.progress);
        const hasProgress = Number.isFinite(progress);
        const isUp = progress > 0;
        const isDown = progress < 0;
        // signed and coloured by direction so the change reads without the icon
        const deltaColor = isUp
          ? "success.main"
          : isDown
          ? "error.main"
          : "text.secondary";
        return (
          <Stack
            key={i}
            sx={{
              flexDirection: "row",
              gap: "24px",
              justifyContent: "space-between",
              // backgroundColor: colors[i],
              borderRadius: "8px",
              padding: "16px",
              minWidth: "calc(25% - 28.5px)",
              backgroundColor: "#fff",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              // color: "#fff",
              // flexGrow:'1'
            }}
          >
            <Stack gap="8px">
              <Typography variant="h5" lineHeight="29px">
                {formatValue(value)}
              </Typography>
              <Typography fontWeight="600" lineHeight="19px">
                {value.label}
              </Typography>
            </Stack>
            {hasProgress && (
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "4px",
                  height: "20px",
                  color: deltaColor,
                }}
              >
                {isUp && <ArrowUpwardRoundedIcon sx={{ fontSize: 16 }} />}
                {isDown && <ArrowDownwardRoundedIcon sx={{ fontSize: 16 }} />}
                <Typography lineHeight="19px" fontWeight={600} color="inherit">
                  {isUp ? "+" : ""}
                  {progress}%
                </Typography>
              </Stack>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};
